import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '@components/ResponsiveModal';
import closeIcon from '@assets/icons/close.svg';
import theme from '@app/theme';

const Icon = styled.img`
  width: ${theme.spacing(18)};
  height: ${theme.spacing(18)};
  cursor: pointer;
  z-index: ${theme.constants.zIndex.coachMark};
  margin-left: 93%;
  margin-top: -8px;
`;

const ArrowUp = styled.div`
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 18px solid white;
  z-index: ${theme.constants.zIndex.coachMark};
  margin-top: -6vh;
  margin-left: 30vw;
  margin-left: ${props => props.marginLeft};
`;

const Container = styled.div`
  padding: 5vh 12px 0px 12px;
`;

const classNames = { overlay: 'modal__overlay' };

const customStyles = ({
  width = '100%',
  height = '20%',
  top = '40%',
  left = '0',
  right = '0',
}) => ({
  modal: {
    borderRadius: '6px',
    fontFamily: theme.fonts.mainFont,
    marginTop: top,
    marginLeft: left,
    marginRight: right,
    display: 'flex',
    flexDirection: 'column',
    color: theme.colors.textPrimary,
    padding: '0px',
    width,
    height,
  },
  overlay: {
    zIndex: theme.constants.zIndex.coachMark,
  },
});

function CoachMark({
  open,
  onClose,
  width = '100%',
  height = 'auto',
  top = '70%',
  left = '0',
  right = '0',
  arrowUpMarginLeft = '75%',
  children,
}) {
  return (
    <Modal
      classNames={classNames}
      styles={customStyles({ width, height, top, left, right })}
      open={open}
      showCloseIcon={false}
      center
      onClose={() => {}}
    >
      <Container>
        <ArrowUp marginLeft={arrowUpMarginLeft} />
        <Icon src={closeIcon} id="close_modal" onClick={onClose} />
        {children}
      </Container>
    </Modal>
  );
}

CoachMark.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  top: PropTypes.string,
  left: PropTypes.string,
  right: PropTypes.string,
  arrowUpMarginLeft: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default CoachMark;
